"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var lodash_1 = require("lodash");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var core_link_1 = require("@reverbdotcom/commons/dist/components/core_link");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
var metadata_helper_1 = require("./metadata_helper");
var bind_1 = require("../../../bind");
var CSPSquareCard = /** @class */ (function (_super) {
    tslib_1.__extends(CSPSquareCard, _super);
    function CSPSquareCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CSPSquareCard, "defaultProps", {
        get: function () {
            return {
                trackName: 'CSPSquareCard',
                trackContext: {},
            };
        },
        enumerable: true,
        configurable: true
    });
    CSPSquareCard.prototype.trackClick = function () {
        if (!this.props.page) {
            return;
        }
        if (this.props.skipTracking) {
            return;
        }
        var _a = this.props, page = _a.page, position = _a.position, trackName = _a.trackName, trackContext = _a.trackContext;
        var event = {
            position: position,
            componentName: trackName,
            type: tracker_1.CSP_TYPE,
            entityId: page.id,
            url: page.webLink(),
            context: trackContext,
        };
        if (page.slug) {
            event.mParticleInteraction = {
                position: position,
                componentName: trackName,
                eventName: mparticle_tracker_1.MParticleEventName.ClickedCSPCard,
                cspId: page.id,
                cspSlug: page.slug,
                brand: '',
                category: '',
                subcategories: '',
                displayStyle: 'CSPSquareCardV3',
            };
        }
        tracker_1.trackInteraction(event);
    };
    CSPSquareCard.prototype.titleWithBrandRemoved = function () {
        if (!this.props.page) {
            return null;
        }
        if (!this.props.stripBrandFromTitle) {
            return this.props.page.title;
        }
        var brandName = lodash_1.get(this.props, 'page.brand.name');
        if (!brandName) {
            return this.props.page.title;
        }
        var regex = new RegExp("^" + brandName + " ", 'i');
        return this.props.page.title.replace(regex, '');
    };
    CSPSquareCard.prototype.backgroundStyles = function () {
        if (!this.props.page) {
            return null;
        }
        return { backgroundImage: "url(" + this.props.page.gridImageHref() + ")" };
    };
    CSPSquareCard.prototype.priceAndCount = function () {
        if (this.props.conditionFilter === 'new') {
            var _a = this.props.page, newLowPrice = _a.newLowPrice, newListingsCount = _a.newListingsCount;
            return { count: newListingsCount, price: newLowPrice };
        }
        if (this.props.conditionFilter === 'used') {
            var _b = this.props.page, usedLowPrice = _b.usedLowPrice, usedListingsCount = _b.usedListingsCount;
            return { count: usedListingsCount, price: usedLowPrice };
        }
        var count = this.props.page.usedListingsCount + this.props.page.newListingsCount;
        var price = this.props.page.lowestPrice();
        return { count: count, price: price };
    };
    CSPSquareCard.prototype.renderCalloutLanguage = function () {
        if (!this.props.page) {
            return null;
        }
        var _a = this.priceAndCount(), price = _a.price, count = _a.count;
        if (price.amount_cents === 0) {
            return I18n.t('discovery.comparisonShoppingPages.priceForFreeHighlightedCount', { count: count, price: price.display, tagOpen: '<b>', tagClose: '</b>' });
        }
        return I18n.t('discovery.comparisonShoppingPages.priceFromWithHighlightedCount', { count: count, price: price.display, tagOpen: '<b>', tagClose: '</b>' });
    };
    CSPSquareCard.prototype.renderPlaceholderCard = function () {
        return (React.createElement("div", { className: "csp-square-card csp-square-card--placeholder" },
            React.createElement("a", { className: "csp-square-card__inner", href: "#" },
                React.createElement("div", { className: "csp-square-card__main" },
                    React.createElement("div", { className: "csp-square-card__image" }),
                    React.createElement("div", { className: "csp-square-card__title" })),
                React.createElement("div", { className: "csp-square-card__details" }))));
    };
    CSPSquareCard.prototype.renderPriceMetadata = function () {
        var inventory = {
            usedLowPrice: this.props.page.usedLowPrice,
            usedTotal: this.props.page.usedListingsCount,
            newLowPrice: this.props.page.newLowPrice,
            newTotal: this.props.page.newListingsCount,
        };
        if (this.props.conditionFilter === 'new') {
            return React.createElement(metadata_helper_1.PriceMetaData, { newOnly: true, inventory: inventory });
        }
        if (this.props.conditionFilter === 'used') {
            return React.createElement(metadata_helper_1.PriceMetaData, { usedOnly: true, inventory: inventory });
        }
        return React.createElement(metadata_helper_1.PriceMetaData, { inventory: inventory });
    };
    CSPSquareCard.prototype.webLink = function () {
        if (this.props.conditionFilter === 'new') {
            return this.props.page.newListingsLink();
        }
        if (this.props.conditionFilter === 'used') {
            return this.props.page.usedListingsLink();
        }
        return this.props.page.webLink();
    };
    CSPSquareCard.prototype.renderTitle = function () {
        return (React.createElement("h3", { className: "csp-square-card__title" }, this.titleWithBrandRemoved()));
    };
    CSPSquareCard.prototype.render = function () {
        var classes = classNames('csp-square-card', { 'csp-square-card--horizontal': this.props.renderAsHorizontal });
        if (!this.props.page) {
            return this.renderPlaceholderCard();
        }
        if (this.props.hideMetadata) {
            return (React.createElement("article", { className: classes, onClick: this.trackClick },
                React.createElement("a", { href: this.webLink(), className: "csp-square-card__inner" },
                    React.createElement("div", { className: "csp-square-card__main" },
                        React.createElement("div", { className: "csp-square-card__image", style: this.backgroundStyles() }),
                        !this.props.renderAsHorizontal && this.renderTitle()),
                    React.createElement("div", { className: "csp-square-card__details" },
                        this.props.renderAsHorizontal && this.renderTitle(),
                        React.createElement("div", { className: "csp-square-card__details__price" },
                            React.createElement(sanitized_render_1.default, { html: this.renderCalloutLanguage() }))))));
        }
        return (React.createElement("article", { className: classes, onClick: this.trackClick, itemScope: true, itemType: "http://schema.org/Product" },
            React.createElement(core_link_1.default, { to: this.webLink(), className: "csp-square-card__inner" },
                React.createElement("div", { className: "csp-square-card__main" },
                    React.createElement("div", { className: "csp-square-card__image", style: this.backgroundStyles() }),
                    React.createElement(metadata_helper_1.BrandMetaData, { brandName: lodash_1.get(this.props, 'page.brand.name') }),
                    React.createElement(metadata_helper_1.NameMetaData, { title: this.props.page.title }),
                    !this.props.renderAsHorizontal &&
                        React.createElement("h3", { className: "csp-square-card__title", itemProp: "model" }, this.titleWithBrandRemoved())),
                React.createElement("div", { className: "csp-square-card__details", itemScope: true, itemProp: "offers", itemType: "http://schema.org/AggregateOffer" },
                    this.props.renderAsHorizontal &&
                        React.createElement("h3", { className: "csp-square-card__title", itemProp: "model" }, this.titleWithBrandRemoved()),
                    React.createElement("div", { className: "csp-square-card__details__price" },
                        this.renderPriceMetadata(),
                        React.createElement(sanitized_render_1.default, { html: this.renderCalloutLanguage() }))))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], CSPSquareCard.prototype, "trackClick", null);
    return CSPSquareCard;
}(React.Component));
exports.default = CSPSquareCard;
//# sourceMappingURL=csp_square_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/csp_square_card.js
// module id = FozY
// module chunks = 20 21